import { useEffect } from "react";
import { pb, API_BASE_URL } from "../lib/pocketbaseConfig";
import { useUser } from "../contexts/UserContext";
import { useDeviceType } from "../contexts/DeviceTypeContext";

export default function DailyLoginTracker() {
  const { currentUser, loading } = useUser();
  const deviceType = useDeviceType();

  const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

useEffect(() => {
  if (loading || !currentUser?.$id) return;

  let cancelled = false;
  let closing = false;
  let sessionId: string | null = null;

  const token = pb.authStore.token;

  const startSession = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/worker-api/daily-logins/start`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            deviceType,
            path: window.location.hash || window.location.pathname,
            isLocalhost,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Start session failed: ${response.status}`
        );
      }

      const data = await response.json();

      if (!data.success || !data.sessionId) {
        throw new Error("Invalid session response");
      }

      sessionId = data.sessionId;

      // If the component unmounted before the API responded,
      // close the session immediately.
      if (cancelled) {
        closeSession();
      }
    } catch (error) {
      console.error(
        "Failed to create daily login session:",
        error
      );
    }
  };

  const closeSession = () => {
    if (closing || !sessionId) return;

    closing = true;

    fetch(
      `${API_BASE_URL}/worker-api/daily-logins/end`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          sessionId,
        }),
        keepalive: true,
      }
    ).catch((error) => {
      console.error(
        "Failed to close daily login session:",
        error
      );
    });
  };

  startSession();

  const handlePageHide = () => {
    cancelled = true;
    closeSession();
  };

  window.addEventListener("pagehide", handlePageHide);

  return () => {
    cancelled = true;

    window.removeEventListener(
      "pagehide",
      handlePageHide
    );

    closeSession();
  };
}, [currentUser?.$id, currentUser?.isGuest, deviceType, loading]);

  return null;
}